import {
  CommunicationSizeComponent,
  ComponentIds,
  Entity,
  GuestConnectionsComponent,
  PlacementResult
} from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const replaceShelfWithCabinet = ({
  coreApi,
  props,
  rootState,
  entity
}: BehaviorParameters & { entity?: Entity }): PlacementResult | undefined => {
  const selectedEntity = entity ?? coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return;
  }

  const product = rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId);

  const newProductType =
    rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId)?.type || '';
  const oldProductType = coreApi.entities.getProductType(selectedEntity) || '';

  if (!product?.type || newProductType === oldProductType) {
    return;
  }

  if (product.type == ProductType.LADMAKARE_COMPARTMENT) {
    return coreApi.products.addToTarget(props.coreProductId, selectedEntity);
  }

  const frame = coreApi.entities.getAncestorsWithComponent(
    selectedEntity,
    ComponentIds.FRAME_COMPONENT_ID
  )?.[0];

  const frameWidth = frame.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size?.width;

  const entityConnection = selectedEntity.getComponent<GuestConnectionsComponent>(
    ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
  )?.connections?.[0];

  const guestKey = entityConnection?.guestConnector.key;
  const hostKey = entityConnection?.hostConnector.key;

  if (guestKey && hostKey && frameWidth === 800) {
    // Cabinet connector is on top, so it will occupy hole & hole -1
    // If bottom host is selected, we must adjust it to 1 to account for it also occupying the hole below
    const adjustedHostKey = hostKey.includes('-0') ? hostKey.replace('-0', '-1') : hostKey;

    // We try to add the cabinet to the hole. AddCabinetSystem will handle the rest
    const replacePlacementResult = coreApi.products.addToConnector(
      props.coreProductId,
      frame,
      guestKey,
      adjustedHostKey
    );

    if (
      replacePlacementResult &&
      replacePlacementResult?.valid &&
      replacePlacementResult.placedEntity
    ) {
      return replacePlacementResult;
    }
  }
};

export default replaceShelfWithCabinet;
